import React, { useState } from 'react';
import { DS } from '../ds';
import { TechnologyEvidenceCard } from '../TechnologyEvidenceCard';
import { SmileDivider } from '../Visuals';
import { H, Label } from '../Primitives';
interface Specification {
  label: string;
  value: string;
  sub: string;
}
const specifications: Specification[] = [{
  label: 'Material',
  value: 'Grado médico',
  sub: 'Seleccionado para un desempeño clínico confiable.'
}, {
  label: 'Precisión',
  value: '±0.1 mm',
  sub: 'Precisión de fabricación.'
}, {
  label: 'Formatos',
  value: '.STL · .OBJ · .PLY',
  sub: 'Compatible con los principales flujos digitales.'
}, {
  label: 'Proceso digital',
  value: 'CAD/CAM Digital',
  sub: 'Flujo completamente digital.'
}, {
  label: 'Control QA',
  value: 'Por unidad',
  sub: 'Inspección individual de cada alineador.'
}, {
  label: 'Laboratorio',
  value: 'Labtek – ADL',
  sub: 'Colombia'
}];
const evidence = [{
  badge: '01 · Escaneo',
  title: 'Diagnóstico digital',
  description: 'Captura intraoral precisa desde sedes aliadas.',
  kind: 'scan' as const
}, {
  badge: '02 · Planificación',
  title: 'Planificación virtual',
  description: 'Movimiento dental diseñado y validado etapa a etapa.',
  kind: 'plan' as const
}, {
  badge: '03 · Fabricación',
  title: 'Producción CNC',
  description: 'Control de calidad individual antes de la entrega.',
  kind: 'fabrication' as const
}];
export const TechnologySection = () => {
  const [hoveredSpec, setHoveredSpec] = useState<number | null>(null);
  return <section id="tecnologia" style={{
    background: DS.color.ivory,
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-745" data-mp="3v1i0nqueox79">
      <SmileDivider fromColor={DS.color.white} toColor={DS.color.ivory} data-id="element-746" data-mp="32e5g1m7t2zgl" />

      {/* Grid CAD sutil sobre ivory */}
      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: 'linear-gradient(rgba(26,95,115,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(26,95,115,0.035) 1px, transparent 1px)',
      backgroundSize: '52px 52px',
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-747" data-mp="37cgn5p6puvv4" />

      <div style={{
      padding: '72px 24px 0',
      position: 'relative',
      zIndex: 1
    }} data-id="element-748" data-mp="j9glnfnethpf">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }} data-id="element-749" data-mp="3rp0e4cg9aw3f">
          {/* Header */}
          <div style={{
          marginBottom: '56px'
        }} data-id="element-750" data-mp="3rqv0lv76ew9m">
            <Label data-id="element-751" data-mp="3mqyw7uukh2tj">Estándares técnicos</Label>
            <H size="lg" data-id="element-752" data-mp="3ms04jrk77b7k">
              Tecnología que puedes revisar
              <br data-id="element-753" data-mp="4lvmtxxki4nb" />
              en cada etapa.
            </H>
          </div>

          {/* Evidence cards */}
          <div className="col-3" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
          marginBottom: '72px'
        }} data-id="element-754" data-mp="3vpakhq7ynoit">
            {evidence.map(item => <TechnologyEvidenceCard key={item.badge} {...item} data-id="element-755" data-mp="1jgluumgs7ofh" />)}
          </div>

          {/* Specifications grid — panel teal se mantiene para contraste */}
          <div className="col-3" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '2px',
          marginBottom: '72px',
          borderRadius: '20px',
          overflow: 'hidden',
          border: `1px solid ${DS.color.border}`,
          boxShadow: DS.shadow.card
        }} data-id="element-756" data-mp="19k0nhuhai18h">
            {specifications.map((spec, index) => <div key={spec.label} onMouseEnter={() => setHoveredSpec(index)} onMouseLeave={() => setHoveredSpec(null)} style={{
            background: hoveredSpec === index ? `linear-gradient(135deg, ${DS.color.tealDeep}, #07202a)` : index % 2 === 0 ? DS.color.white : '#FAFAF8',
            padding: '26px 30px',
            transition: `background 0.25s ${DS.ease.smooth}`,
            cursor: 'default'
          }} data-id="element-757" data-mp="1sg8v34xryo6y" data-mpi={index}>
                <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: hoveredSpec === index ? 'rgba(255,255,255,0.5)' : DS.color.muted,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: '8px',
              transition: `color 0.25s ${DS.ease.smooth}`
            }} data-id="element-758" data-mp="ncoh0p9fnhd3">
                  {spec.label}
                </div>
                <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '1.15rem',
              color: hoveredSpec === index ? DS.color.aquaLight : DS.color.tealDeep,
              marginBottom: '4px',
              transition: `color 0.25s ${DS.ease.smooth}`
            }} data-id="element-759" data-mp="1yz4x0zunjacy">
                  {spec.value}
                </div>
                <div style={{
              fontFamily: DS.font.body,
              fontSize: '12px',
              color: hoveredSpec === index ? 'rgba(255,255,255,0.55)' : DS.color.muted,
              transition: `color 0.25s ${DS.ease.smooth}`
            }} data-id="element-760" data-mp="2p8drz5zsi60o">
                  {spec.sub}
                </div>
              </div>)}
          </div>
        </div>
      </div>

      <SmileDivider fromColor={DS.color.ivory} toColor={DS.color.linen} flip data-id="element-761" data-mp="3cy80xcgznafn" />
    </section>;
};